var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"root",staticClass:"exporo-invest-entry",style:(_vm.getStyles(_vm.index)),attrs:{"id":'list-item-' + _vm.index},on:{"click":function($event){return _vm.open(_vm.index, _vm.data)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }